import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, change } from 'redux-form';
import { Button, Grid, Checkbox, Input } from 'semantic-ui-react';
import _ from 'lodash';

import { MyPlate } from 'Common/Components/MyPlate';
import {
  InputField,
  Checkbox as WrapperCheckbox,
} from 'Common/SemanticWrapper';
import {
  RecipeFieldEnum as Fields,
  RecipeVerified as Verified,
} from 'Common/FieldEnum';
import { InputMode, EDIT_RECIPE_FORM_NAME } from 'Common/FormEnum';

import {
  convertToMyPlate,
  hasWholeValue,
} from 'Common/Components/NutritionalHover/helpers/helpers';
import { COMPONENT_TYPE } from 'Common/Components/NutritionalHover/constants/constants';
import 'Styles/pages/managerecipe/meal-component.less';

class MealComponent extends React.Component {
  static propTypes = {
    formName: PropTypes.string.isRequired,
    isReadOnly: PropTypes.bool,
  };

  static defaultProps = {
    isReadOnly: false,
  };

  unverified = (key) => () => {
    const { formName, change } = this.props;
    change(formName, `${Fields.Verified}.${key}`, false);
  };

  verified = (key) => () => {
    const { formName, change } = this.props;
    change(formName, `${Fields.Verified}.${key}`, true);
  };

  render() {
    const { data, formName, change, isReadOnly } = this.props;

    const vegHasValue =
      hasWholeValue(data[Fields.OtherVeg]) ||
      hasWholeValue(data[Fields.LegumesVeg]) ||
      hasWholeValue(data[Fields.StarchyVeg]) ||
      hasWholeValue(data[Fields.DarkGreenVeg]) ||
      hasWholeValue(data[Fields.AdditionalVeg]) ||
      hasWholeValue(data[Fields.RedOrangeVeg]);

    if (!vegHasValue) {
      data.TotalVeg = '';
    }

    const fruitHasValue = hasWholeValue(data[Fields.Fruit]);

    const milkHasValue = hasWholeValue(data[Fields.Milk]);

    const recipeComponentType = parseInt(data[Fields.ComponentType], 10);

    const disabledDessert =
      !(
        hasWholeValue(data[Fields.WholeGrain]) ||
        hasWholeValue(data[Fields.EnrichedGrain])
      ) ||
      recipeComponentType === COMPONENT_TYPE.Juice ||
      isReadOnly;

    const disabledJuice =
      !(vegHasValue || fruitHasValue) ||
      recipeComponentType === COMPONENT_TYPE.Dessert ||
      isReadOnly;

    const disabledVeg =
      !(
        recipeComponentType !== COMPONENT_TYPE.None ||
        recipeComponentType !== COMPONENT_TYPE.Juice
      ) || isReadOnly;

    const disabledFruit =
      !(
        recipeComponentType !== COMPONENT_TYPE.None ||
        recipeComponentType !== COMPONENT_TYPE.Juice
      ) || isReadOnly;

    const disabledMilk = !milkHasValue || isReadOnly;
    const isVerified = _.get(
      data,
      [Fields.Verified, Verified.MealComponents],
      false
    );

    return (
      <Grid padded className="meal-component">
        <Grid.Row>
          <Grid.Column>
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center' }}>
              <div style={{ width: 171, height: 146 }}>
                <MyPlate
                  selectedComponents={convertToMyPlate(data)}
                  isSmallSize
                />
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column>
            <Button
              onClick={this.verified(Verified.MealComponents)}
              fluid
              color={isVerified ? 'green' : 'orange'}
              disabled={isReadOnly}
            >
              {isVerified ? 'Verified' : 'Click to Verify'}
            </Button>
          </Grid.Column>
        </Grid.Row>
        {formName === EDIT_RECIPE_FORM_NAME && (
          <Grid.Row className="component-row" verticalAlign="middle">
            <Grid.Column width={8}>Serving Size Weight</Grid.Column>
            <Grid.Column width={8} className="component-value">
              <Field
                name={Fields.WeightPerServing}
                component={InputField}
                fluid
                fieldLabel={{ basic: true, content: 'grams' }}
                labelPosition="right"
                hideError
                disabled
              />
            </Grid.Column>
          </Grid.Row>
        )}
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={8}>Meat/Meat Alt.</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.MeatAlt}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'oz eq.' }}
              labelPosition="right"
              hideEmptyError={true}
              onChange={this.unverified(Verified.MealComponents)}
              disabled={isReadOnly}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={8}>Whole Grain - Rich</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.WholeGrain}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'oz eq.' }}
              labelPosition="right"
              hideEmptyError={true}
              onChange={(e, fieldData) => {
                this.unverified(Verified.MealComponents);
                if (
                  !fieldData &&
                  !data[Fields.EnrichedGrain] &&
                  data[Fields.ComponentType] === COMPONENT_TYPE.Dessert
                ) {
                  this.props.change(formName, Fields.ComponentType, null);
                }
              }}
              disabled={isReadOnly}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={8}>Enriched Grain</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.EnrichedGrain}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'oz eq.' }}
              labelPosition="right"
              hideEmptyError={true}
              onChange={(e, fieldData) => {
                this.unverified(Verified.MealComponents);
                if (
                  !fieldData &&
                  !data[Fields.WholeGrain] &&
                  data[Fields.ComponentType] === COMPONENT_TYPE.Dessert
                ) {
                  change(formName, Fields.ComponentType, COMPONENT_TYPE.None);
                }
              }}
              disabled={isReadOnly}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={16}>
            <Checkbox
              disabled={disabledDessert}
              label="Grain Based Dessert"
              onChange={(e, fieldData) => {
                change(
                  formName,
                  Fields.ComponentType,
                  fieldData.checked
                    ? COMPONENT_TYPE.Dessert
                    : COMPONENT_TYPE.None
                );
                this.unverified(Verified.MealComponents)();
              }}
              checked={recipeComponentType === COMPONENT_TYPE.Dessert}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={8}>Vegetables</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Input
              fluid
              disabled
              value={data[Fields.TotalVeg]}
              onChange={(e, fieldData) => {
                if (
                  !fieldData &&
                  !data[Fields.Fruit] &&
                  data[Fields.ComponentType] === COMPONENT_TYPE.Juice
                ) {
                  change(formName, Fields.ComponentType, COMPONENT_TYPE.None);
                }
              }}
              label={{ basic: true, content: 'cups' }}
              labelPosition="right"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={2} />
          <Grid.Column width={6}>Dark Green</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.DarkGreenVeg}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'cups' }}
              labelPosition="right"
              disabled={disabledVeg}
              hideEmptyError={true}
              onChange={this.unverified(Verified.MealComponents)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={2} />
          <Grid.Column width={6}>Red/Orange</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.RedOrangeVeg}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'cups' }}
              labelPosition="right"
              disabled={disabledVeg}
              hideEmptyError={true}
              onChange={this.unverified(Verified.MealComponents)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={2} />
          <Grid.Column width={6}>Beans, Peas, Lentils</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.LegumesVeg}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'cups' }}
              labelPosition="right"
              disabled={disabledVeg}
              hideEmptyError={true}
              onChange={this.unverified(Verified.MealComponents)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={2} />
          <Grid.Column width={6}>Starchy</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.StarchyVeg}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'cups' }}
              labelPosition="right"
              disabled={disabledVeg}
              hideEmptyError={true}
              onChange={this.unverified(Verified.MealComponents)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={2} />
          <Grid.Column width={6}>Other</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.OtherVeg}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'cups' }}
              labelPosition="right"
              disabled={disabledVeg}
              hideEmptyError={true}
              onChange={this.unverified(Verified.MealComponents)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={2} />
          <Grid.Column width={6}>Additional</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.AdditionalVeg}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'cups' }}
              labelPosition="right"
              disabled={disabledVeg}
              hideEmptyError={true}
              onChange={this.unverified(Verified.MealComponents)}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={8}>Fruits</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.Fruit}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'cups' }}
              labelPosition="right"
              disabled={disabledFruit}
              hideEmptyError={true}
              onChange={(e, fieldData) => {
                this.unverified(Verified.MealComponents);
                if (
                  !fieldData &&
                  !data[Fields.TotalVeg] &&
                  data[Fields.ComponentType] === COMPONENT_TYPE.Juice
                ) {
                  change(formName, Fields.ComponentType, COMPONENT_TYPE.None);
                }
              }}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={16}>
            <Checkbox
              disabled={disabledJuice}
              label="Juice"
              onChange={(e, fieldData) => {
                change(
                  formName,
                  Fields.ComponentType,
                  fieldData.checked ? COMPONENT_TYPE.Juice : COMPONENT_TYPE.None
                );
                this.unverified(Verified.MealComponents)();
              }}
              checked={recipeComponentType === COMPONENT_TYPE.Juice}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={8}>Milk</Grid.Column>
          <Grid.Column width={8} className="component-value">
            <Field
              name={Fields.Milk}
              component={InputField}
              mode={InputMode.Decimal}
              numericSize={[12, 3]}
              fluid
              label={null}
              fieldLabel={{ basic: true, content: 'cups' }}
              labelPosition="right"
              hideEmptyError={true}
              onChange={this.unverified(Verified.MealComponents)}
              disabled={isReadOnly}
            />
          </Grid.Column>
        </Grid.Row>

        <Grid.Row className="component-row" verticalAlign="middle">
          <Grid.Column width={16}>
            <Field
              name={Fields.Milk_SkimUnflavored}
              component={WrapperCheckbox}
              label="Skim / Fat Free Unflavored"
              disabled={disabledMilk}
              onChange={this.unverified(Verified.MealComponents)}
            />
            <div>
              <Field
                name={Fields.Milk_SkimFlavored}
                component={WrapperCheckbox}
                label="Skim / Fat Free Flavored"
                disabled={disabledMilk}
                onChange={this.unverified(Verified.MealComponents)}
              />
            </div>
            <div>
              <Field
                name={Fields.Milk_LowFatUnflavored}
                component={WrapperCheckbox}
                label="Low Fat Unflavored"
                disabled={disabledMilk}
                onChange={this.unverified(Verified.MealComponents)}
              />
            </div>
            <div>
              <Field
                name={Fields.Milk_LowFatFlavored}
                component={WrapperCheckbox}
                label="Low Fat Flavored"
                disabled={disabledMilk}
                onChange={this.unverified(Verified.MealComponents)}
              />
            </div>
            <div>
              <Field
                name={Fields.Milk_ReducedWholeUnflavoredFlavored}
                component={WrapperCheckbox}
                label="Reduced Whole Unflavored Flavored"
                disabled={disabledMilk}
                onChange={this.unverified(Verified.MealComponents)}
              />
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
const mapDispatchToProps = {
  change,
};
const connected = connect(null, mapDispatchToProps)(MealComponent);

export { connected as MealComponent };



// WEBPACK FOOTER //
// ./src/common/Components/MealComponent/MealComponent.js